import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { branch, renderNothing } from 'recompose'

import TooltipButtonComponent from 'components/custom/ValidationTooltip/index'

class ConfigValidationTooltip extends Component {
  render() {
    const {
      isRisk,
    } = this.props

    const TooltipButton = branch(
      () => !isRisk,
      renderNothing
    )(TooltipButtonComponent)

    return(
      <TooltipButton />
    )
  }
}

ConfigValidationTooltip.propTypes = {
  isRisk: PropTypes.bool.isRequired
}

export default ConfigValidationTooltip
